import { render, staticRenderFns } from "./CustomerSearchCustom.vue?vue&type=template&id=a65ec424&"
import script from "./CustomerSearchCustom.vue?vue&type=script&lang=ts&"
export * from "./CustomerSearchCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports